import { Content, ContentBox, Separator } from "./Content";

export const Container = {
  Content,
  ContentBox,
  Separator,
};
